function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Podhero_Mark_Color",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "Oval",
  fill: "#FFFFFF",
  cx: 256.023301,
  cy: 257.498796,
  rx: 252.023301,
  ry: 254.498796
}), /*#__PURE__*/React.createElement("path", {
  d: "M156.763052,492.03899 C175.727385,500.014356 195.851038,505.782108 216.809237,509.001032 L216.809237,295.187217 C216.809237,273.633173 234.445697,255.996925 256,255.996925 C277.554303,255.996925 295.190763,273.633173 295.190763,295.187217 L295.190763,347.187427 C330.504794,331.993121 355.236948,296.880955 355.236948,255.996925 C355.236948,201.188892 310.80458,156.761169 256,156.761169 C201.19542,156.761169 156.763052,201.188892 156.763052,255.996925 L156.763052,403.306873 C109.477606,371.397186 78.3815259,317.329136 78.3815259,255.996925 C78.3815259,157.90403 157.905927,78.3805843 256,78.3805843 C354.094073,78.3805843 433.618474,157.90403 433.618474,255.996925 C433.618474,338.134975 377.856016,407.249335 302.130237,427.561853 C300.395369,428.026398 287.334522,431.056215 295.190763,429.276146 L295.190763,509.017476 C417.971769,490.152035 512,384.054997 512,255.996925 C512,114.615058 397.387676,1.70530257e-13 256,1.70530257e-13 C114.616435,1.70530257e-13 0,114.615058 0,255.996925 C0,362.188516 64.6629089,453.268021 156.763052,492.03899 Z",
  id: "Logo",
  fill: "#0067FF"
})));

function SvgPodhero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Podhero_Mark_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPodhero);
export default __webpack_public_path__ + "static/media/podhero.0323c1db.svg";
export { ForwardRef as ReactComponent };